import * as React from 'react';
import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';
import { compose } from 'redux';

import type { RootState } from 'af-reducers';

import { setDailyTipCollapsed } from 'af-utils/settings.util';

interface OwnProps {
	dueDate: string;
	isCollapsed: boolean;
	setDailyTipsSectionCollapsed: (value: boolean) => void;
}

type Props = OwnProps & ConnectedProps<typeof connector>;

const DailyTipSection: React.FC<Props> = (props) => {
	const { dailyTip, perDiemMessage, isCollapsed, setDailyTipsSectionCollapsed } = props;

	const toggleDailyTipSection = React.useCallback(() => {
		setDailyTipsSectionCollapsed(!isCollapsed);
		setDailyTipCollapsed(!isCollapsed);
	}, [isCollapsed, setDailyTipsSectionCollapsed]);

	return (
		<div className={`tips ${isCollapsed ? 'tips--collapsed' : ''}`}>
			<div className="tip">
				<div className="tip__title">DAILY TIP MESSAGE</div>
				<div>{dailyTip}</div>
			</div>
			<div className="tip">
				<div className="tip__title">PER DIEM MESSAGE</div>
				<div>{perDiemMessage}</div>
			</div>
			<span className={`btn btn--icon btn-primary tips__toggle-icon icon-${isCollapsed ? 'up' : 'down'}`} onClick={toggleDailyTipSection} />
		</div>
	);
};

function mapStateToProps(state: RootState, ownProps: OwnProps) {
	const { dueDate } = ownProps;

	const stateOnDate = state?.scheduleBoard?.workOrdersByDateDictionary?.[dueDate];

	return {
		dailyTip: stateOnDate?.dailyTip?.message ?? '',
		perDiemMessage: stateOnDate?.dailyPerDiemTip?.message ?? '',
	};
}

const connector = connect(mapStateToProps);

const enhance = compose<React.ComponentType<OwnProps>>(
	React.memo,
	connector
);

export default enhance(DailyTipSection);
